const posts = [
   {
    slug: "Dotfiles with Nix Home Manager",
    path: "/blog/HowToDotsInNix.md",
    title: "❄️ How to Manage Dotfiles with Nix Home Manager",
    date: "09.05.2026",
    slug: "Dotfiles-With-Nix-Home-Manager"
  },
  {
    slug: "Keycloak Security Concept",
    path: "/blog/KeycloakSecurityConcept.md",
    title: "Implementing a Security Concept with Keycloak",
    date: "01.05.2026",
    slug: "Keycloak-security-concept"
  },
  {
    slug: "DeveloperBlog",
    path: "/blog/DeveloperBlog.md",
    title: "Building my First Developer Blog",
    date: "01.05.2026",
    slug: "Building-developer-Blog",
  }
];

export default posts;